import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/gtf_logo_primary_2.png'
import _imports_1 from '@/assets/fi-rr-globe.png'
import _imports_2 from '@/assets/cancel_button_2.png'
import _imports_3 from '@/assets/gtf_logo_gray.png'
import _imports_4 from '@/assets/main_help_icon.png'
import _imports_5 from '@/assets/back_icon.png'
import _imports_6 from '@/assets/main_help_black_icon.png'
import _imports_7 from '@/assets/arrow_left_black_icon.png'
import _imports_8 from '@/assets/home_icon_2.png'


const _withScopeId = n => (_pushScopeId("data-v-22b59fac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-wrap header-wrap--between" }
const _hoisted_2 = {
  key: 0,
  class: "languages"
}
const _hoisted_3 = { class: "languages__popup" }
const _hoisted_4 = { class: "languages__popup--title" }
const _hoisted_5 = { class: "languages__list" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "select-box__inner" }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = { class: "language__text" }
const _hoisted_11 = { class: "languages__close-btn" }
const _hoisted_12 = {
  key: 1,
  class: "header-wrap header-wrap--transparent"
}
const _hoisted_13 = {
  key: 2,
  class: "header-wrap"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-icon" }, null, -1))
const _hoisted_15 = {
  key: 3,
  class: "header-wrap"
}
const _hoisted_16 = {
  key: 5,
  class: "header-wrap header-wrap--center"
}
const _hoisted_17 = { class: "page-title" }
const _hoisted_18 = {
  key: 6,
  class: "header-wrap header-wrap--center"
}
const _hoisted_19 = { class: "page-title" }
const _hoisted_20 = {
  key: 8,
  class: "header-wrap header-wrap--center"
}
const _hoisted_21 = { class: "page-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.path === '/' || $setup.path.trim() === '')
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("img", {
            class: "logo-img",
            src: _imports_0,
            alt: "logo",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.moveToHome && $setup.moveToHome(...args)))
          }),
          _createElementVNode("img", {
            class: "globe-img",
            src: _imports_1,
            alt: "languages",
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.isLanguagesPopupOpen = true))
          })
        ]),
        _createVNode(_Transition, { name: "fade-op" }, {
          default: _withCtx(() => [
            ($setup.isLanguagesPopupOpen)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('select_language')), 1),
                    _createElementVNode("ul", _hoisted_5, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.languages, (lang) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: lang.code,
                          class: "languages__item language",
                          onClick: ($event: any) => ($setup.selectLanguage(lang.code))
                        }, [
                          _createElementVNode("div", {
                            class: _normalizeClass(['language__select-box', { 'language__select-box--selected': lang.code === $setup.currentLang }])
                          }, _hoisted_8, 2),
                          _createElementVNode("img", {
                            class: "language__flag",
                            src: lang.icon,
                            alt: `${lang.name}_icon`
                          }, null, 8, _hoisted_9),
                          _createElementVNode("span", _hoisted_10, _toDisplayString(lang.description), 1)
                        ], 8, _hoisted_6))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("img", {
                      src: _imports_2,
                      alt: "close languages popup",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.isLanguagesPopupOpen = false))
                    })
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ], 64))
    : ($setup.path === '/check-wifi')
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("img", {
            class: "logo-img",
            src: _imports_3,
            alt: "logo",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.moveToHome && $setup.moveToHome(...args)))
          }),
          _createElementVNode("img", {
            class: "help-icon",
            src: _imports_4,
            alt: "help",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.moveToGuide && $setup.moveToGuide(...args)))
          })
        ]))
      : ($setup.path === '/guide')
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("img", {
              class: "back-icon",
              src: _imports_5,
              alt: "back",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.moveToBack && $setup.moveToBack(...args)))
            }),
            _createElementVNode("div", null, _toDisplayString($setup.pageTitle), 1),
            _hoisted_14
          ]))
        : ($setup.path === '/wifi')
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("img", {
                class: "back-icon",
                src: _imports_5,
                alt: "back",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => ($setup.moveToBack && $setup.moveToBack(...args)))
              }),
              _createElementVNode("div", null, _toDisplayString($setup.pageTitle), 1),
              _createElementVNode("img", {
                class: "help-icon",
                src: _imports_6,
                alt: "help",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => ($setup.moveToGuide && $setup.moveToGuide(...args)))
              })
            ]))
          : ($setup.path.endsWith('/receipts/scan'))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [], 64))
            : ($setup.path.endsWith('/city/receipts') || $setup.path.endsWith('/terminal/receipts'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("img", {
                    class: "back-icon",
                    src: _imports_7,
                    alt: "back",
                    onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => ($setup.moveToHome && $setup.moveToHome(...args)))
                  }),
                  _createElementVNode("div", _hoisted_17, _toDisplayString($setup.pageTitle), 1)
                ]))
              : (
      (
        $setup.path.endsWith('/city/done') ||
        $setup.path.endsWith('/terminal/done') ||
        $setup.path.endsWith('/history')
      ) && !$setup.path.endsWith('/refund/method/history'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createElementVNode("img", {
                      class: "home-icon",
                      src: _imports_8,
                      alt: "home",
                      onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => ($setup.moveToHome && $setup.moveToHome(...args)))
                    }),
                    _createElementVNode("div", _hoisted_19, _toDisplayString($setup.pageTitle), 1)
                  ]))
                : ($setup.path.endsWith('/tips'))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [], 64))
                  : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createElementVNode("img", {
                        class: "back-icon",
                        src: _imports_7,
                        alt: "back",
                        onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => ($setup.moveToBack && $setup.moveToBack(...args)))
                      }),
                      _createElementVNode("div", _hoisted_21, _toDisplayString($setup.pageTitle), 1)
                    ]))
}